import { useContext, useEffect, useState } from "react";
import {
    MdCall,
    MdEmail,
    MdLocationOn,
    MdClose
} from "react-icons/md";
import { FaFacebook, FaInstagram, FaLinkedin, FaRegCopyright, FaYoutube } from "react-icons/fa";
import { schoolContext } from "../contexts/SchoolContextProvider";
import { mediaSource } from "../utilities/mediautilities"
import { useTranslation } from "react-i18next";
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const Footer = () => {
    const { schoolDetails } = useContext(schoolContext);
    const [socialMediaLinks, setSocialMediaLinks] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        setSociallinks();
    }, [schoolDetails]);

    const SOCIAL_CONFIG = [
        { key: "facebook", icon: FaFacebook },
        { key: "instagram", icon: FaInstagram },
        { key: "twitter", icon: MdClose },
        { key: "youtube", icon: FaYoutube },
        { key: "linkedin", icon: FaLinkedin },
    ]

    const setSociallinks = async () => {
        const socialLinks = SOCIAL_CONFIG
            .filter(item => schoolDetails?.[item.key])
            .map(item => ({
                icon: item.icon,
                url: schoolDetails?.[item.key],
            }));

        setSocialMediaLinks(socialLinks);
    }

    return (
        <>
            <footer className="bg-primary text-accent pt-14">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-12 items-start">

                    {/* Logo */}
                    <div className="flex flex-col items-center md:items-start">
                        <div className="w-40 h-40 bg-accent rounded-full flex items-center justify-center mb-6 shadow-lg">
                            <img src={mediaSource(schoolDetails?.logo?.fileUrl)} alt="School Logo" className="h-100 w-100" onError={(e) => mediaSource(e)} />
                        </div>
                    </div>

                    {/* Contact */}
                    <div>
                        <h3 className="text-secondary text-xl font-semibold mb-4">
                            {t(I18N_KEYS.CONTACTUSTITLE1)}
                        </h3>

                        {(schoolDetails?.contact_number || schoolDetails?.email || schoolDetails?.address) &&
                            <div className="space-y-4 text-sm">
                                {schoolDetails?.contact_number &&
                                    <p className="flex items-center gap-3">
                                        <MdCall size={20} />
                                        {schoolDetails?.contact_number}
                                    </p>
                                }
                                {schoolDetails?.email &&
                                    <p className="flex items-center gap-3">
                                        <MdEmail size={20} />
                                        {schoolDetails?.email}
                                    </p>
                                }
                                {schoolDetails?.address &&
                                    <p className="flex items-center gap-3">
                                        <MdLocationOn size={22} />
                                        {schoolDetails?.address}
                                    </p>
                                }
                            </div>
                        }
                    </div>

                    {/* Social */}
                    <div>
                        <h3 className="text-secondary text-xl font-semibold mb-4">
                            {t(I18N_KEYS.FOOTERLINKTITLE)}
                        </h3>

                        {socialMediaLinks?.length > 0 &&
                            <div className="flex gap-4">
                                {socialMediaLinks?.map(
                                    (link, i) => (
                                        <a
                                            key={i}
                                            href={link?.url}
                                            target="_blank"
                                            className="w-11 h-11 border border-accent rounded-md
                                               flex items-center justify-center
                                               hover:bg-secondary hover:text-[#1f3375]
                                               transition duration-300 cursor-pointer"
                                        >
                                            <link.icon size={22} />
                                        </a>
                                    )
                                )}
                            </div>
                        }
                    </div>
                </div>

                {/* Bottom */}
                <div className="mt-12 py-4 text-sm boext-center rder-t border-accent/20 text-center flex justify-center items-center gap-1">
                    <FaRegCopyright /> {t(I18N_KEYS.FOOTERRIGHTS)} <b>{schoolDetails?.name}</b>
                </div>
            </footer>
        </>
    );
}

export default Footer;